class CartRecommendationsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations();
  }

  async loadRecommendations() {
    /*
     * Ostoskorissa olevien tuotteiden ID:t
     */
    const productIds = [
      ...new Set(
        (this.dataset.productIds || "")
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean)
      ),
    ];

    /*
     * Ostoskorissa jo olevien tuotteiden handlet.
     * Näitä ei näytetä suosituksissa.
     */
    const cartProductHandles = new Set(
      (this.dataset.cartProductHandles || "")
        .split(",")
        .map((handle) => handle.trim())
        .filter(Boolean)
    );

    if (!productIds.length) {
      return;
    }

    try {
      /*
       * Haetaan complementary-suositukset jokaiselle
       * ostoskorissa olevalle tuotteelle.
       */
      const requests = productIds.map((productId) => {
        const url =
          `${window.Shopify.routes.root}recommendations/products` +
          `?section_id=cart-recommendations` +
          `&product_id=${encodeURIComponent(productId)}` +
          `&limit=3` +
          `&intent=complementary`;

        return fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Recommendation request failed for product ${productId}`
              );
            }

            return response.text();
          })
          .catch((error) => {
            console.error(error);
            return "";
          });
      });

      const responses = await Promise.all(requests);

      /*
       * Kaikki uniikit suositukset kerätään tähän.
       */
      const recommendationItems = [];
      const seenHandles = new Set();

      /*
       * Otetaan myös talteen ensimmäinen section,
       * jossa oikeasti on suosituksia.
       */
      let baseSection = null;

      responses.forEach((text) => {
        if (!text) return;

        const html = document.createElement("div");
        html.innerHTML = text;

        const section = html.querySelector(
          "#shopify-section-cart-recommendations"
        );

        if (!section) return;

        const items = section.querySelectorAll(
          ".f-cart-recommendations__item"
        );

        if (!items.length) return;

        /*
         * Ensimmäisestä toimivasta vastauksesta
         * otetaan karusellin rakenne pohjaksi.
         */
        if (!baseSection) {
          baseSection = section.cloneNode(true);
        }

        items.forEach((item) => {
          /*
           * Haetaan product handle tuotteen linkistä.
           */
          const productLink = item.querySelector(
            'a[href*="/products/"]'
          );

          if (!productLink) return;

          let handle = "";

          try {
            const productUrl = new URL(
              productLink.getAttribute("href"),
              window.location.origin
            );

            const match = productUrl.pathname.match(
              /\/products\/([^/?#]+)/
            );

            if (match && match[1]) {
              handle = match[1];
            }
          } catch (error) {
            return;
          }

          if (!handle) return;

          /*
           * Älä näytä tuotetta, jos se on jo ostoskorissa.
           */
          if (cartProductHandles.has(handle)) {
            return;
          }

          /*
           * Älä näytä samaa suositusta kahdesti.
           */
          if (seenHandles.has(handle)) {
            return;
          }

          seenHandles.add(handle);

          if (recommendationItems.length < 6) {
  recommendationItems.push(
    item.cloneNode(true)
  );
}
        });
      });

      /*
       * Ei yhtään suositusta -> ei näytetä mitään.
       */
      if (
        !baseSection ||
        !recommendationItems.length
      ) {
        this.innerHTML = "";
        return;
      }

      /*
       * Pohjasectionin flickity-container.
       */
      const productsContainer =
        baseSection.querySelector(
          "[data-products-container]"
        );

      if (!productsContainer) {
        this.innerHTML = "";
        return;
      }

      /*
       * Poistetaan pohjasta sen alkuperäiset tuotteet.
       */
      productsContainer
        .querySelectorAll(
          ".f-cart-recommendations__item"
        )
        .forEach((item) => {
          item.remove();
        });

      /*
       * Lisätään kaikkien ostoskorituotteiden
       * yhdistetyt suositukset.
       */
      recommendationItems.forEach((item) => {
        productsContainer.appendChild(item);
      });

      /*
       * Jos lopputuloksena on vain yksi tuote,
       * lisätään teeman oma one-product-luokka.
       */
      const itemsWrapper =
        baseSection.querySelector(
          ".f-cart-recommendations__items"
        );

      if (itemsWrapper) {
        if (recommendationItems.length === 1) {
          itemsWrapper.classList.add(
            "f-cart-recommendations__items-only-product"
          );
        } else {
          itemsWrapper.classList.remove(
            "f-cart-recommendations__items-only-product"
          );
        }
      }

      /*
       * Renderöidään valmis yhteinen karuselli.
       */
      this.innerHTML = baseSection.innerHTML;
    } catch (error) {
      console.error(
        "Cart recommendations error:",
        error
      );

      this.innerHTML = "";
    }
  }
}

if (!customElements.get("cart-recommendations-component")) {
  customElements.define(
    "cart-recommendations-component",
    CartRecommendationsComponent
  );
}


/*
 * QUICK ADD SUOSITUSTUOTTEELLE
 *
 * Tämä osa vastaa vanhan tiedostosi toimintaa,
 * eli suosituksesta voidaan edelleen lisätä
 * tuote suoraan ostoskoriin.
 */
if (!customElements.get("add-to-cart-component")) {
  class AddToCartComponent extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer =
        document.querySelector("cart-drawer");

      this.addToCartButton =
        this.querySelector(
          ".f-cart-recommendations__item-add-to-cart"
        );

      this.addEventListener(
        "click",
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler() {
      if (!this.addToCartButton) {
        return;
      }

      this.addToCartButton.classList.add(
        "btn--loading"
      );

      const variantId =
        this.dataset.variantId;

      if (!variantId) {
        this.addToCartButton.classList.remove(
          "btn--loading"
        );

        return;
      }

      const config = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      const formData = new FormData();

      formData.append("id", variantId);
      formData.append("quantity", 1);

      if (this.cartDrawer) {
        formData.append(
          "sections",
          this.cartDrawer
            .getSectionsToRender()
            .map((section) => section.id)
        );

        formData.append(
          "sections_url",
          window.location.pathname
        );
      }

      config.body = formData;

      fetch(
        `${FoxThemeSettings.routes.cart_add_url}`,
        config
      )
        .then((response) =>
          response.json()
        )
        .then((response) => {
          if (response.status) {
            return this.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "warning",
              message: response.description,
              last: 3000,
              sticky: true,
            });
          }

          window.FoxThemeEvents.emit(
            PUB_SUB_EVENTS.cartUpdate,
            response
          );
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.addToCartButton.classList.remove(
            "btn--loading"
          );
        });
    }
  }

  customElements.define(
    "add-to-cart-component",
    AddToCartComponent
  );
}